
























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import CartItem from '@/components/panier/CartItem.vue'
import EditPlat from '@/components/carte/EditPlat.vue'
import { groupByNumber } from '@/utils/groupBy';
import { ItemPanier } from '@/models/alo/ItemPanier';
import { mixins } from 'vue-class-component'
import PlatEditable from '@/components/carte/PlatEditable'

@Component({
  name: 'MenuBreakfastEditCarte',
  components:{
    CartItem,EditPlat
  }
})
export default class MenuBreakfastEditCarte extends mixins(PlatEditable) {
   
  private showEdit = false
  showHoraire = false  

  get panier() {
    return this.$store.myGetters.panier    
  }  

  editItemPanier(item:ItemPanier) {    
    (this.$refs.editPlat as EditPlat).edit(item)
    this.showEdit = true
  }  

  //regroupement du panier par section
  get panierGroup(){
    return groupByNumber(this.itemPanier.supplements,it => it.sectionId || 0)
  }

  get platsDic(){    
    return this.$store.myGetters.platsDic
  }  
  
  udpateQty(qty:number,uuid:string) {
    const index = this.itemPanier.supplements.findIndex(it => it.uuid == uuid)
    if(index > -1) {
      if(qty == 0){
        this.itemPanier.supplements.splice(index,1)
        if(this.itemPanier.supplements.length == 0) this.isEdited = false      
      }
      else{
        this.itemPanier.supplements[index].qty = qty
      }
    }    
  }

  udpateSupplements(item:ItemPanier){
    const index = this.itemPanier.supplements.findIndex(it => it.uuid == item.uuid)
    if(index > -1) this.itemPanier.supplements.splice(index,1,item)     
  }
}
